export const STATUS_TYPES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DRAFT: 'DRAFT',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REVIEW_CANCEL: 'REVIEW_CANCEL',
  READY_FOR_REVIEW: 'PENDING_APPROVAL',
  RETURNED: 'RETURNED',
  PENDING_APPROVAL: 'PENDING_APPROVAL'
};

export const STATUS_CLASSTYPES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DRAFT: 'draft',
  READY_FOR_REVIEW: 'ready-for-review',
  PENDING_APPROVAL: 'Pending Approval',
  RETURNED: 'returned'
};

export const allStatusList = [
  { value: STATUS_TYPES.ACTIVE, label: 'Active' },
  { value: STATUS_TYPES.INACTIVE, label: 'Inactive' },
  { value: STATUS_TYPES.DRAFT, label: 'Draft' },
  { value: STATUS_TYPES.PENDING_APPROVAL, label: 'Pending Approval' },
  { value: STATUS_TYPES.RETURNED, label: 'Returned' }
];

export const FILTER = {
  TO_TIMESTAMP_EXTENSION_STR: 'T23:59:59',
  FROM_TIMESTAMP_EXTENSION_STR: 'T00:00:00'
};

export const UTCFILTER = {
  UTC_TO_TIMESTAMP_EXTENSION_STR: '.999Z',
  UTC_FROM_TIMESTAMP_EXTENSION_STR: '.001Z'
};
